<template>
  <div>
    <Table :columns="columns" :data="tableList" row-key="id">
      <template #header="{ row }">
        {{ 123 }}
      </template>
      <template #rewardType="{ row }">
        {{ getResourceName(row.rewardType) }}
      </template>

      <template #rewardIcon="{ row }">
        <el-image
          style="width: 40px; height: 40px"
          :src="row.rewardIcon"
          fit="contain"
        ></el-image>
      </template>
      <template #rewardLevel="{ row }">
        <Tag :color="row.rewardLevel === 1 ? 'success' : 'error'">{{
          row.rewardLevel === 1 ? '低等价值' : '高等价值'
        }}</Tag>
      </template>
      <template #mark="{ row }">
        <span v-if="!row.mark">-</span>
        <Tag v-else :color="row.mark === 1 ? 'success' : 'warning'">{{
          row.mark === 1 ? 'Rare' : 'New'
        }}</Tag>
      </template>
      <template #notice="{ row }">
        <Tag type="border" v-if="row.notice > 0" color="primary">
          {{
            row.notice === 1
              ? '房间公屏'
              : row.notice === 2
              ? '全服'
              : '房间公屏+全服'
          }}
        </Tag>
        <span v-else>-</span>
      </template>
      <template #action="{ row }">
        <Button size="small" type="primary" @click="handleEdit(row)">编辑</Button>
      </template>
    </Table>
  </div>
</template>

<script>
export default {
  props: {
    tableList: {
      type: Array,
      default: () => [],
    },
    rsList: {
      type: Array,
      default: () => [],
    },
    docId: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    tableList(newVal) {
      this.renderTableList = newVal.map((item, index) => {
        let boxTypeList = [9001, 9002, 9003]
        if (boxTypeList.includes(item.rewardType)) {
          item.rewardDetailList = item.rewardDetailList.map((detail) => {
            detail.rewardId = detail.rewardRelationId
            detail.notice = '-'
            detail.rewardLevel = '-'
            detail.rewardType = detail.type
            detail.id = Math.random()
            return detail
          })
          item.children = item.rewardDetailList
        }
        return {
          ...item,
        }
      })
      console.log(this.renderTableList)
    },
  },
  data() {
    return {
      renderTableList: [],
      columns: [],
      columns1: [
        {
          title: '排序',
          align: 'center',
          key: 'orderId',
        },
        {
          title: '奖品ID',
          align: 'center',
          key: 'rewardId',
        },

        {
          title: '奖品预览',
          align: 'center',
          key: 'rewardIcon',
          slot: 'rewardIcon',
        },
        {
          title: '奖品类型',
          align: 'center',
          key: 'rewardType',
          slot: 'rewardType',
          tree: true,
          display: 'inline',
        },
        {
          title: '奖品名称',
          align: 'center',
          key: 'rewardName',
        },
        {
          title: '奖品价值',
          align: 'center',
          key: 'price',
        },
        {
          title: '展示价值',
          align: 'center',
          key: 'showPrice',
        },
        {
          title: '概率',
          align: 'center',
          key: 'rate',
        },
        {
          title: '价值类型',
          align: 'center',
          key: 'rewardLevel',
          width: '120',
          slot: 'rewardLevel',
        },
        {
          title: '角标',
          align: 'center',
          key: 'mark',
          width: '100',
          slot: 'mark',
        },
        {
          title: '广播',
          align: 'center',
          width: '160',
          key: 'notice',
          slot: 'notice',
        },
        {
          title: '幸运奖池数量',
          align: 'center',
          key: 'luckyCount',
        },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          width: 100,
          slot: 'action',
        },
      ],
      columns2: [
        {
          title: '排序',
          align: 'center',
          key: 'orderId',
        },
        {
          title: '奖品ID',
          align: 'center',
          key: 'rewardId',
        },

        {
          title: '奖品预览',
          align: 'center',
          key: 'rewardIcon',
          slot: 'rewardIcon',
        },
        {
          title: '奖品类型',
          align: 'center',
          key: 'rewardType',
          slot: 'rewardType',
          tree: true,
          display: 'inline',
        },
        {
          title: '奖品名称',
          align: 'center',
          key: 'rewardName',
        },
        {
          title: '奖品价值',
          align: 'center',
          key: 'price',
        },
        {
          title: '展示价值',
          align: 'center',
          key: 'showPrice',
        },
        {
          title: '普通奖池数量',
          align: 'center',
          key: 'normalCount',
        },
        {
          title: '普通奖池剩余数量',
          align: 'center',
          key: 'normalSurplusCount',
        },
        {
          title: '价值类型',
          align: 'center',
          key: 'rewardLevel',
          width: '120',
          slot: 'rewardLevel',
        },
        {
          title: '角标',
          align: 'center',
          key: 'mark',
          width: '100',
          slot: 'mark',
        },
        {
          title: '广播',
          align: 'center',
          width: '160',
          key: 'notice',
          slot: 'notice',
        },
        {
          title: '低价值奖池数量',
          align: 'center',
          key: 'trdCount',
        },
        {
          title: '低价值奖池剩余数量',
          align: 'center',
          key: 'trdSurplusCount',
        },
        {
          title: '高净值奖池数量',
          align: 'center',
          key: 'luckyCount',
        },
        {
          title: '高净值奖池剩余数量',
          align: 'center',
          key: 'luckySurplusCount',
        },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          width: 100,
          slot: 'action',
        },
      ],
      total: 0,
    }
  },
  onMounted() {
    this.columns = this.columns1
  },
  watch: {
    docId: {
      immediate: true,
      handler(val) {
        if (val > 3) {
          this.columns = this.columns2
        } else {
          this.columns = this.columns1
        }
        console.log("======");
        console.log(val)
        console.log(this.columns)
        this.$forceUpdate()
      },
    },
  },
  methods: {
    getResourceName(type) {
      let item = this.rsList.find((item) => item.value === type)
      return item ? item.name : ''
    },
    handleEdit(row) {
      this.$emit('open', true, row)
    },
  },
}
</script>

<style scoped lang="scss"></style>
<style>
.ivu-avatar > img {
  object-fit: contain;
}

.ivu-table-row[style] {
  td {
    background-color: #dbdbdb !important;
  }
}
</style>
